import { render, staticRenderFns } from "./Step5-Footer.vue?vue&type=template&id=768acdc5&"
import script from "./Step5-Footer.vue?vue&type=script&lang=js&"
export * from "./Step5-Footer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports